module.exports = "/static/assets/ce132277cd371cc58054ea72cd0cd95b.png";